import { PEAD } from "../../../consts";
import type { ChartData } from "../../../types";
import { getColorForLabel } from "../getColorForLabel";
import { getColorForLine } from "../getColorForLine";

export function generateSeriesList(
	rankingMap: Map<string, ChartData>,
	isMainChart: boolean,
): echarts.SeriesOption[] {
	const seriesList: echarts.SeriesOption[] = [];

	rankingMap.forEach((data, name) => {
		const series: echarts.SeriesOption = {
			name,
			color: getColorForLine(name),
			stackStrategy: "all",
			type: "line",
			symbolSize: 5,
			showAllSymbol: true,
			smooth: true,
			emphasis: {
				focus: "series",
				label: {
					show: true,
				},
			},

			endLabel: {
				show: true,
				fontWeight: "bold",
				fontSize: isMainChart ? 14 : 12,
				formatter: () => {
					const lastDataPoint = data.at(-1);
					return Array.isArray(lastDataPoint) ? `$${lastDataPoint[1]}` : "";
				},
				offset: getLabelPositionForLines(name, isMainChart),
				color: getColorForLabel(name),
			},

			lineStyle: {
				width: name.startsWith("S") ? 1 : isMainChart ? 2 : 1.5,
				type: name.startsWith("S") ? "dotted" : "solid",
				color: getColorForLine(name),
			},
			data,
			animation: false,
		};

		seriesList.push(series);
	});

	return seriesList;
}

function getLabelPositionForLines(
	name: string,
	isMainChart: boolean,
): number[] {
	switch (name) {
		case PEAD.LINE.PRICE:
		case PEAD.LINE.MAX:
		case PEAD.LINE.SIGMA_1:
		case PEAD.LINE.SIGMA_2:
			return isMainChart ? [-60, 10] : [-50, 10];
		default:
			return isMainChart ? [-60, -10] : [-50, -10];
	}
}
